module.exports = new __parcel__URL__("raffle_rock_icon.6eaa5df8.png").toString();